import React from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux'

import { search, toggleBranch, requestBranchContent, BROWSE_FORWARD_BRANCH_CONTENT, requestFileContent, BROWSE_FORWARD_FILE_CONTENT } from './browse-actions'

import BrowseFolders from './browse-folders'
import BrowseFiles from './browse-files'
import Search from '../form/form-search'
import ListPagify from '../list/list-pagify'

import HttpService from 'commonjs-tools/build/http-service'

class Browse extends React.Component {
    static propTypes = {
        conf: PropTypes.shape({
            service: PropTypes.instanceOf(HttpService).isRequired,
            reducer: PropTypes.string.isRequired
        }),
        root: PropTypes.object.isRequired,
        views: PropTypes.object.isRequired,
        filter: PropTypes.func.isRequired
    }

    constructor(props) {
        super(props)
        this.state={};
        this.query = {}
        this.search = this.search.bind(this);
        this.requestFile = this.requestFile.bind(this);
        this.requestFiles = this.requestFiles.bind(this);
        this.requestFolders = this.requestFolders.bind(this);
    }

    requestFolders(branch) {
        let { dispatch, conf } = this.props;
        branch.subBranches = [];
        branch.subBranchesFetching = true;
        branch.expanded = !branch.expanded;
        branch.expanded && toggleBranch(dispatch, conf, branch).then((rst)=>{
            branch.subBranches = rst.data.collection;
            branch.subBranchesCount = rst.data.collectionCount;
            branch.subBranchesFetching = false;
            this.setState({branch});
        }, err => console.error(err));
        this.setState({branch});
    }

    requestFiles(branch) {
        let { conf, dispatch } = this.props;
        return query => {
            //keep query from other component but override other by news from query
            Object.assign(this.query, query);
            query = this.query;
            let contentPromise = requestBranchContent(dispatch, conf, branch, query);
            contentPromise.then(result => dispatch({type: BROWSE_FORWARD_BRANCH_CONTENT, result}));
            return contentPromise;
        }
    }

    requestFile(file) {
        let { conf, dispatch } = this.props;
        let contentPromise = requestFileContent(dispatch, conf, file);
        contentPromise.then(result => dispatch({type: BROWSE_FORWARD_FILE_CONTENT, result}));
        return contentPromise;
    }

    search(value) {
        let { conf, dispatch } = this.props;
        search(dispatch, conf, value).then((data)=>{
            this.setState({root: {
                subBranches: data.collection,
                subBranchesCount: data.collectionCount,
                isFetching: false,
                expanded: true
            }});
        }, err => console.error(err));
    }

    render() {
        let { views, filter } = this.props;
        let { root, dispatch, page, branchContentLoading=false } = this.props;
        root = this.state.root || root;
        let { branch=root } = this.props;
        let { files={} } = branch;
        let { collection=[], collectionCount=collection.length } = files;

        console.log('Browse files', files);
        console.log('Browse property', page);
        console.log('Browse collection', collection);
        console.log('Browse collectionCount', collectionCount);

        return <div className='browse'>
            <div className="browse-tree">
                <Search label="app.components.browse.search" placeholder="app.components.browse.search" onChange={this.search} onSelect={console.log}/>
                <BrowseFolders parent={root} requestFolders={this.requestFolders} requestFiles={this.requestFiles} />
            </div>

            <div className="browse-content">
                { React.createElement(filter, { onFilters: this.requestFiles(branch) }) }
                <BrowseFiles loading={branchContentLoading} branch={branch} views={views} requestFile={ this.requestFile } />
                <ListPagify onClick={this.requestFiles(branch)} collectionCount={collectionCount} current={page} elementByPage={collection.length}/>
            </div>
        </div>
    }
}

function mapStateToProps(state) {
    let { branch, query={}, branchContentLoading } = state.browseReducers;
    let { page=0, count } = query;

    return { ...state, branchContentLoading, branch, page, count }
}

export default connect(mapStateToProps)(Browse)
